export enum RootNavigationRoute {
  booking = 'booking',
  menu = 'menu',
}
